import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

export type GetLineItemRejectedByLogisticianQuantityParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * A Line item can be split into different parts in the context of a return request.
 * This function returns the quantity of the line item that has been rejected by the logistician.
 *
 * For example, the order contains 3 white t-shirt
 *
 * ***********************************
 * White t-shirt                   x3
 * ***********************************
 *
 * The customer returns 3 white t-shirt.
 * The merchant has validated 1 white t-shirt.
 * The logistician has rejected 1 white t-shirt.
 *
 * This function would return 1 (item rejected by logistician)
 */
export function getLineItemRejectedByLogisticianQuantity({
  lineItem,
}: GetLineItemRejectedByLogisticianQuantityParams) {
  const validatedByLogistician = lineItem.logistician_informations.reduce(
    (acc, logisticianInformation) => {
      if (logisticianInformation.status === "ok") {
        return acc + logisticianInformation.quantity;
      }
      return acc;
    },
    0,
  );

  const rejectedByLogistician = lineItem.logistician_informations.reduce(
    (acc, logisticianInformation) => {
      if (logisticianInformation.status === "rejected") {
        return acc + logisticianInformation.quantity;
      }
      return acc;
    },
    0,
  );

  const treatedByMerchant = lineItem.merchant_informations.reduce(
    (acc, merchantInformation) => acc + merchantInformation.quantity,
    0,
  );

  // we prioritize validated over rejected, thus this calculus matches first validated by logistician with treated by merchant then the rejected by logistician ones
  return Math.max(
    0,
    rejectedByLogistician - (treatedByMerchant - validatedByLogistician),
  );
}
